import bowser from 'bowser';

// setup polyfil for IE10/IE11
(function() {
    const find = Array.prototype.find;
})();

export default bowser;
